var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout_popup",class:{ shadow: _vm.shadow },style:({ width: _vm.width, height: _vm.height })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }